
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiForceDirectionRelative as ObiForceDirectionRelativeElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-force-direction-relative.js';
 
 
 

 
 export const ObiForceDirectionRelative = createComponent({
   react: React,
   tagName: 'obi-force-direction-relative',
   elementClass: ObiForceDirectionRelativeElement,
   events: {
     
   }
  });
 
 